import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { useTheme, SPACING, BORDER_RADIUS, TYPOGRAPHY } from '../../theme';
import { Structure } from '../../types';

interface PropertyTilesProps {
  structure: Structure;
}

function Tile({ label, value }: { label: string; value: string }) {
  const { colors } = useTheme();
  return (
    <View
      style={[
        styles.tile,
        { backgroundColor: colors.surfaceElevated, borderColor: colors.borderLight },
      ]}>
      <Text style={[styles.label, { color: colors.textTertiary }]}>{label}</Text>
      <Text style={[styles.value, { color: colors.text }]} numberOfLines={1}>
        {value}
      </Text>
    </View>
  );
}

export function PropertyTiles({ structure }: PropertyTilesProps) {
  const tiles: { label: string; value: string }[] = [];
  if (structure.propertyType) tiles.push({ label: 'Type', value: structure.propertyType });

  if (tiles.length === 0) return null;

  return (
    <View style={styles.row}>
      {tiles.map((t) => (
        <Tile key={t.label} label={t.label} value={t.value} />
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    gap: SPACING.sm,
  },
  tile: {
    flex: 1,
    borderWidth: 1,
    borderRadius: BORDER_RADIUS.md + 2,
    paddingVertical: SPACING.smd,
    paddingHorizontal: SPACING.smd,
  },
  label: {
    ...TYPOGRAPHY.overline,
    letterSpacing: 1,
  },
  value: {
    ...TYPOGRAPHY.button, // already SemiBold; fontWeight 500 was a no-op
    marginTop: 4,
    letterSpacing: -0.1,
  },
});
